import {connect} from 'react-redux';
import * as VideoActions from '../../store/actions/videoActions';
import LectureDropdown from '../../components/EditChapterPart/LectureDropdown';


const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({
    loadCourse: (courseId, token) => {
        dispatch(VideoActions.loadSlimCourses(courseId, token));
    }
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LectureDropdown);


// WEBPACK FOOTER //
// ./src/containers/EditChapterPart/LectureDropdownContainer.js